/** @jsx jsx */
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { ClassAttributes, ReactElement } from 'react';

type AspectRatio = [number, number];
type Length = string | number;

export type Props = {
  aspectRatio: AspectRatio;
  width?: Length;
  height?: Length;
  className?: string;
  children?: ReactElement<any>;
};

type StyledComponentProps = {
  width?: Length;
  height?: Length;
};

// ReactのcloneElementではcssに対応していないため、emotionのjsxを使うようにする
// https://github.com/emotion-js/emotion/issues/1102#issuecomment-446887725
const cloneElement = (element: ReactElement, props: any) =>
  jsx(element.type, {
    key: element.key,
    ...element.props,
    ...props,
  });

const AspectRatioFixed = ({
  aspectRatio,
  width = '100%',
  height = 'auto',
  className,
  children,
}: ClassAttributes<HTMLElement> & Props) => {
  return (
    <Root width={width} height={height} className={className}>
      <Space aspectRatio={aspectRatio} />

      {children
        ? cloneElement(children, {
            css: {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            },
          })
        : null}
    </Root>
  );
};

const Root = styled('div')<StyledComponentProps>(({ width, height }) => ({
  position: 'relative',
  width,
  height,
}));

const Space = styled('div')<{ aspectRatio: AspectRatio }>(({ aspectRatio }) => ({
  paddingTop: `${(100 / aspectRatio[0]) * aspectRatio[1]}%`,
}));

export default AspectRatioFixed;
